<template>

    <div class="card card-raised card-background mt-2 trax-card-with-background" :style="'background-image: url('+backgroundUrl+')'">
        <div :class="'card-body '+alignClass">
            <div class="w-100">
                <slot></slot>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            verticalAlign: null,
            backgroundFolder: {default: app_url+'polaris/img/lib/backgrounds'},
            backgroundImage: {default: 'default.jpg'}
        },

        computed: {

            alignClass: function() {
                if (this.verticalAlign) return 'd-flex align-items-'+this.verticalAlign;
                return '';
            },

            // The content records the code of a background, and the images are managed
            // in Settings > Backgrounds: window.backgrounds gives their current URL.
            // A full URL is also accepted, as well as an image of the static folder.
            backgroundUrl: function() {
                var backgrounds = window.backgrounds || {};
                if (backgrounds[this.backgroundImage]) {
                    return backgrounds[this.backgroundImage];
                }
                if (/^(https?:)?\/\//.test(this.backgroundImage) || this.backgroundImage.charAt(0) == '/') {
                    return this.backgroundImage;
                }
                return this.backgroundFolder + '/' + this.backgroundImage;
            }
        }
    }
</script>
